import Vue from 'vue';
import Vuex from 'vuex';
import auth from './modules/auth';
import carriers from './modules/carriers';
import claimTypes from './modules/claimTypes';
import claims from './modules/claims';
import clusterUsers from './modules/clusterUsers';
import companies from './modules/companies';
import customers from './modules/customers';
import filters from './modules/filters';
import followUps from './modules/followUps';
import guard from './modules/guard';
import jobs from './modules/jobs';
import leads from './modules/leads';
import loader from './modules/loader';
import movers from './modules/movers';
import notifications from './modules/notifications';
import plans from './modules/plans';
import roles from './modules/roles';
import timezones from './modules/timezones';
import transactions from './modules/transactions';
import trucks from './modules/trucks';
import uniqueKey from './modules/uniqueKey';
import users from './modules/users';
import values from './modules/values';

Vue.use(Vuex);

const vuexStore = new Vuex.Store({
  modules: {
    auth,
    carriers,
    claimTypes,
    claims,
    clusterUsers,
    companies,
    customers,
    filters,
    followUps,
    guard,
    jobs,
    leads,
    loader,
    movers,
    notifications,
    plans,
    roles,
    timezones,
    transactions,
    trucks,
    uniqueKey,
    users,
    values,
  },
});

export default vuexStore;



// WEBPACK FOOTER //
// ./src/store/store.js